/* ------------------------------------*\
    VARIABLE DECLARATION
\*------------------------------------*/

$(window).on('load', () => {
    /*------------------------------------*\
        CALL TO FUNCTIONS
    \*------------------------------------*/


    if (isArchiveBA()) {
        console.log(
            '<!-- ----------------------------------------------------- -->\n' +
        '<!-- A – BA -->\n' +
        '<!-- ----------------------------------------------------- -->');
        setupABA();
    } else if(isSingleBA()) {
        console.log(
            '<!-- ----------------------------------------------------- -->\n' +
        '<!-- S – WN -->\n' +
        '<!-- ----------------------------------------------------- -->');
        setupSBA()
    }

});

/*------------------------------------*\
HOME
\*------------------------------------*/
function setupABA() {
    //specific for mobile
    if(deviceDetector.device == 'desktop'){
        // You're on a desktop.
        // console.log('desktop');
    }else{
        if(deviceDetector.device == 'tablet'){
            // You're on a tablet.
            // console.log('tablet');
        }else{
            // console.log('phone');
        }
        // You're on a phone.
    }
    setupPopUpNonMembers();
}

function setupSBA() {
    //specific for mobile
    if(deviceDetector.device == 'desktop'){
        // You're on a desktop.
        // console.log('desktop');
    }else{
        if(deviceDetector.device == 'tablet'){
            // You're on a tablet.
            // console.log('tablet');
        }else{
            // console.log('phone');
        }
        // You're on a phone.
    }
    setupPopUpNonMembers();


}

function setupPopUpNonMembers(){
    var $popup_button = $('.popup_add_to_bag , .nonmember-popup-close');
    var $popup_container = $('.nonmember-popup');
    $popup_button.on('click',function(){
        $popup_container.toggleClass('active');
    });
}

/*------------------------------------*\
ARCHIVE
\*------------------------------------*/

/*------------------------------------*\
SINGLE
\*------------------------------------*/



/*------------------------------------*\
jQuery Events
\*------------------------------------*/
$(window).on('scroll', function () {

});


/*------------------------------------*\
Extra methods
\*------------------------------------*/

